import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { toArray } from '@kcast-fe/core';
import { Svg } from '../../../../../../base';
const MenuItemFC = ({ item, activeId, hideActive, onClose }) => {
    const activeIds = toArray(activeId);
    return (_jsx(Box, { p: '6px 8px', fontSize: '16px', fontWeight: 500, borderRadius: '4px', bg: activeIds.includes(item.id) ? '{colors.bgSurface}' : 'inherit', color: item.isDanger ? '{colors.stateError}' : 'inherit', _hover: { bg: '{colors.bgSurface}', cursor: 'pointer' }, onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            item.onClick?.();
            onClose();
        }, children: _jsxs(Flex, { alignItems: 'center', gap: '8px', children: [!hideActive && (_jsx(Box, { w: '20px', children: activeIds.includes(item.id) && _jsx(Svg, { size: 's20', name: 'Check' }) })), _jsxs(Flex, { alignItems: 'center', gap: '8px', children: [item.icon && _jsx(Svg, { name: item.icon, size: 's20' }), _jsx(Box, { children: item.name }), item.isExternal && (_jsx(Box, { p: '0 0 2px 0', children: _jsx(Svg, { name: 'ExternalLink', size: 's16' }) }))] })] }) }, item.name));
};
export const MenuItem = memo(MenuItemFC);
//# sourceMappingURL=MenuItem.js.map